<template>
  <field-group class="my-1" :label="label" inline>
    <div>
      <div class="flex flex-column mb-2 pa-2" v-if="form && form.length > 0">
        <div
          class="d-flex pa-2 mb-2 align-center"
          v-for="(item, index) of form"
          :key="index"
        >
          <v-text-field
            single-line
            hide-details
            dense
            outlined
            class="mt-2 flex-grow-1"
            label="y"
            type="number"
            :suffix="item.unit || 'px'"
            :value="item"
            @input="
              form[index] = $event
              emitInput()
            "
          />
          <div class="align-center">
            <base-button
              icon
              small
              type-action="delete"
              @click="onRemove(form, index)"
            />
          </div>
        </div>

        <base-button icon small type-action="create" @click="form.push(1)">
        </base-button>
      </div>
      <div v-else>
        <div>
          Không cài đặt
        </div>

        <base-button icon small type-action="create" @click="onInit()">
        </base-button>
      </div>
    </div>
  </field-group>
</template>

<script>
export default {
  props: {
    label: String,
    value: {},
    fields: { type: Array },
    option: { type: Object, default: () => ({}) },
  },
  data: () => ({}),
  computed: {
    form: {
      get() {
        return this.value
      },
      set(value) {
        if (!value || value.length == 0) {
          this.$emit('input', undefined)
          return
        }
        this.$emit(
          'input',
          value.map((e) => e * 1)
        )
      },
    },
  },
  methods: {
    emitInput() {
      if (!this.value || this.value.length == 0) {
        this.$emit('input', undefined)
        return
      }
      this.$emit(
        'input',
        this.value.map((e) => e * 1)
      )
    },
    onRemove(array, index) {
      if (array) array.splice(index, 1)
      this.emitInput()
    },
    onInit() {
      this.form = [1, 1]
    },
  },
}
</script>

<style scoped></style>
